import { createContext, useContext } from 'react';

import type { HelpSidebarContextValue } from 'components/help_sidebar/HelpSidebar';

export const HelpSidebarContext = createContext({} as HelpSidebarContextValue);
HelpSidebarContext.displayName = 'HelpSidebarContext';

export const useHelpSidebar = () => useContext(HelpSidebarContext);